import gql from 'graphql-tag';
import {
  configuredAtaFragment,
  configuredDeviceFragment,
  condominiumVirtualPabxFragment,
  deviceFragment,
  phoneRegionSettingsOptionFragment,
  virtualPabxOperatingScheduleFragment,
} from './fragments';

export const configuredDevices = gql`
  query configuredDevices($condominiumId: Int!) {
    configuredDevices(condominiumId: $condominiumId) {
      ...configuredDeviceParts
    }
  }
  ${configuredDeviceFragment}
`;

export const configuredAtas = gql`
  query configuredAtas($condominiumId: Int!) {
    configuredAtas(condominiumId: $condominiumId) {
      ...configuredAtaParts
    }
  }
  ${configuredAtaFragment}
`;

export const availableDevices = gql`
  query availableDevices($condominiumId: Int!) {
    availableDevices(condominiumId: $condominiumId) {
      ...devicePartsForSipConfiguration
    }
  }
  ${deviceFragment}
`;

export const configuredIntercom = gql`
  query configuredIntercom($condominiumId: Int!) {
    configuredIntercom(condominiumId: $condominiumId) {
      ...configuredDeviceParts
    }
  }
  ${configuredDeviceFragment}
`;

export const phoneRegionSettingsOptions = gql`
  query phoneRegionSettingsOptions {
    phoneRegionSettingsOptions {
      ...phoneRegionSettingsOptionParts
    }
  }
  ${phoneRegionSettingsOptionFragment}
`;

export const condominiumVirtualPabx = gql`
  query condominiumVirtualPabx($condominiumId: Int!) {
    condominiumVirtualPabx(condominiumId: $condominiumId) {
      ...condominiumVirtualPabxParts
    }
  }
  ${condominiumVirtualPabxFragment}
`;

export const virtualPabxOperatingSchedules = gql`
  query virtualPabxOperatingSchedules($virtualPabxId: Int!) {
    virtualPabxOperatingSchedules(virtualPabxId: $virtualPabxId) {
      ...virtualPabxOperatingScheduleParts
    }
  }
  ${virtualPabxOperatingScheduleFragment}
`;
